import { useQuery } from "@tanstack/react-query";
import api from "../../api/apiClient";
import { StoreNotificationsResponse } from "../../types/notification";

export interface StoreNotificationPaginationParams {
    page: number;
    limit: number;
    type?: string;
}

export const useStoreNotifications = ({
    page,
    limit,
    type,
}: StoreNotificationPaginationParams) => {
    const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
    });

    if (type) {
        queryParams.append("type", type);
    }

    return useQuery({
        queryKey: ["store-notifications", page, limit, type],
        queryFn: () =>
            api
                .get<StoreNotificationsResponse>(`store-notification?${queryParams.toString()}`)
                .then((res) => res.data),
        staleTime: 30000,
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: true,
        refetchOnMount: true,
    });
};

export const useStoreUnreadNotificationCount = () => {
    return useQuery({
        queryKey: ["store-notifications-unread-count"],
        queryFn: () =>
            api
                .get<{ count: number }>(`store-notification/unread-count`)
                .then((res) => res.data.count),
        refetchInterval: 60000,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: true,
        refetchOnMount: true,
        staleTime: 30000,
        gcTime: 5 * 60 * 1000,
    });
};
